'use client'

import PropTypes from 'prop-types'
import MUITypography from '@mui/material/Typography'
import MUIStack from '@mui/material/Stack'

export const EmptyState = ({ heading, text, secondaryText, icon, textVariant = 'body1', sx }) => {
  return (
    <MUIStack
      data-testid="EmptyState"
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        width: '100%',
        height: '100%',
        minHeight: '240px',
        overflowX: 'hidden',
        overflowY: 'hidden',
        ...sx
      }}
    >
      {icon ? icon : null}
      {heading ? <MUITypography variant="h4">{heading}</MUITypography> : null}
      <MUITypography variant={textVariant}>{text || 'No results found'}</MUITypography>
      {secondaryText ? (
        <MUITypography sx={{ mt: 4 }} variant={textVariant}>
          {secondaryText}
        </MUITypography>
      ) : null}
    </MUIStack>
  )
}

EmptyState.propTypes = {
  heading: PropTypes.string,
  text: PropTypes.string,
  secondaryText: PropTypes.string,
  icon: PropTypes.node,
  textVariant: PropTypes.string,
  sx: PropTypes.object
}
